﻿module.exports = (function ($) {
    return {
        init: function () {

            var self = this;
            self.alignTitleHeights();

            $(window).resize(function () {
                // Reset height
                self.alignTitleHeights();
            });
        },
        alignTitleHeights: function () {
            $('.panelGrid .panelGrid__title').height('auto');
            $('.panelGrid').each(function(){
                var cols = parseInt($(this).attr('data-cols'));
                if(cols > 1)
                    $(this).find('.panelGrid__title').equalizeHeights(cols);

            });
        }
    };
});